import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { hasPermission$ } from '../core/state/user/user.store';
import { DATA_CATALOGUE } from '../constants/permissions';

@Component({
    selector: 'giq-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    standalone: false
})
export class SupportComponent {
  public showCatalog = false;
  public enableDataCatalogue$: Observable<boolean | undefined> =
    hasPermission$(DATA_CATALOGUE);
  /**
   *
   */
  constructor() {
    this.showCatalog = environment.dataCatalog != null;
  }

  public openGuide() {
    window.open('/assets/quick-start-guide.pdf', '_blank');
  }

  public openDNADashboard() {
    window.open(
      'https://devglobelifeinc.atlassian.net/jira/plans/15/scenarios/15/timeline?vid=193',
      '_blank'
    );
  }

  public openDataCatalog(): void {
    if (environment.dataCatalog != null) {
      window.open(environment.dataCatalog, '_blank');
    }
  }
}
